/* src/app/shared/ui-kit/pa-bulk-actions-bar/pa-bulk-actions-bar.component.scss */
@media (max-width: 1199px) {
  .pa-bulk-actions-bar {
    bottom: 10px;
    left: 10px;
    z-index: 100;
    position: fixed;
  }
}
@media (max-width: 767px) {
  .pa-bulk-actions-bar {
    bottom: 70px;
    right: 10px;
    left: unset;
    z-index: 100;
    position: fixed;
  }
}
.pa-bulk-actions-bar__inner {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 4px 12px;
  border-radius: 32px;
  background: var(--primary-subtle-inverse);
  color: var(--contrast-inverse);
}
.pa-bulk-actions-bar__left {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.pa-bulk-actions-bar__right {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.pa-bulk-actions-bar__counter {
  font-size: 14px;
  color: var(--text-fixed-inverse);
  white-space: nowrap;
}
.pa-bulk-actions-bar__divider {
  width: 1px;
  height: 24px;
  background: #EDEFF1;
  margin: 0 4px;
}
.pa-bulk-actions-bar__close ::ng-deep .p-button,
.pa-bulk-actions-bar__select-all ::ng-deep .p-button,
.pa-bulk-actions-bar__select-all-icon ::ng-deep .p-button,
.pa-bulk-actions-bar__action ::ng-deep .p-button {
  min-width: auto;
  background: transparent;
  border: none;
  color: #ffffff;
  box-shadow: none;
}
pa-context-menu ::ng-deep .p-button {
  color: #ffffff;
}
/*# sourceMappingURL=pa-bulk-actions-bar.component.css.map */
